import { DownloadSimple } from "@phosphor-icons/react";

const LINKS = [
  { href: "/downloads/Aikyam-FPE-Client-Operating-Guide.docx", testid: "fp-download-client-guide",
    label: "Client Operating Guide (.docx)",
    cls: "bg-terracotta text-white hover:bg-terracotta/90" },
  { href: "/downloads/Aikyam-FPE-Coverage-Methodology.docx", testid: "fp-download-coverage-method",
    label: "Coverage Methodology (.docx)",
    cls: "border border-border bg-card text-navy hover:bg-muted" },
  { href: "/downloads/FP_Input_Templates_Starter_Pack.zip", testid: "fp-download-templates-zip",
    label: "Excel Templates (.zip)",
    cls: "border border-border bg-card text-navy hover:bg-muted" },
  { href: "/downloads/Aikyam-FPE-Calculation-Logic-Guide.docx", testid: "fp-download-calc-logic",
    label: "Calculation Logic Guide (.docx)",
    cls: "border border-border bg-card text-navy hover:bg-muted" },
  { href: "/downloads/Aikyam-FPE-Fixed-Cost-Consolidation-Guide.docx", testid: "fp-download-fc-consolidation",
    label: "Fixed Cost Guide (.docx)",
    cls: "border border-border bg-card text-navy hover:bg-muted" },
  { href: "/downloads/FP_Framework_Input_and_Configuration_Guide.docx", testid: "fp-download-framework-guide",
    label: "Framework Guide (.docx)",
    cls: "bg-navy text-white hover:bg-navy/90" },
];

export const FpDownloadButtons = () => (
  <div className="flex flex-wrap items-center gap-2" data-testid="fp-download-buttons">
    {LINKS.map((l) => (
      <a key={l.testid} href={l.href} download data-testid={l.testid}
         className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold transition ${l.cls}`}>
        <DownloadSimple size={14} />
        {l.label}
      </a>
    ))}
  </div>
);
